// Persists the user's last-used chart view — electricity zone (ALL/SE1–4) and
// forecast range (7d/30d) — so a bare visit (no URL params) restores where they
// usually go, instead of always resetting to the default. Per-device via
// localStorage; explicit URL params always win over this, so shared links are
// unaffected. (`chart` is retained for back-compat; electricity is the only asset.)

const KEY = "sp:lastView";

export interface ViewPreference {
  chart?: string;
  area?: string;
  range?: string;
}

export function readViewPreference(): ViewPreference {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return parsed as ViewPreference;
    return {};
  } catch {
    // Corrupt JSON / disabled storage (private mode) — fall back to no preference.
    return {};
  }
}

export function writeViewPreference(pref: ViewPreference): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(pref));
  } catch {
    // Quota exceeded / storage disabled — preference persistence is best-effort.
  }
}
